import { EVENTS } from '../../bus/events.const';
import { URLStoreMode } from '../../models';
import { ACTIONS_KEYS, GETTERS_KEYS, MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const URL_WIRES = createWires({
  loadStateFromURL: (observable, { store, emit }) => {
    observable.subscribe(() => {
      store.dispatch(ACTIONS_KEYS.url.loadStateFromURL, window.location.href).then(() => {
        if (!!store.state.search.query) {
          emit(EVENTS.OpenEmpathyX);
        } else { // popstate of history state without query
          store.commit(MUTATIONS_KEYS.search.clearSearch);
          if (store.getters[GETTERS_KEYS.config.config].searchBox.autofocus) {
            emit(EVENTS.FocusSearchInput);
          }
        }
      });
    });
  },
  pushURL: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.url.storeURL, URLStoreMode.NEW),
  replaceURL: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.url.storeURL, URLStoreMode.REPLACE)
});
